interface ComputerWithEyeAndChipSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithEyeAndChipSVG = ({
  color,
  style,
}: ComputerWithEyeAndChipSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="50"
    viewBox="0 0 58 50"
    fill="none"
  >
    <g clipPath="url(#clip0_564_17589)">
      <path
        d="M46.9928 20.1782V39.6155C46.9928 41.6022 45.382 43.213 43.3953 43.213H4.19854C2.21186 43.213 0.601036 41.6022 0.601036 39.6155V13.7027C0.601036 11.716 2.21186 10.1052 4.19854 10.1052H36.8338"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.85488 35.8033H43.7389"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.954 39.5081C18.954 39.7336 18.7714 39.9162 18.5459 39.9162C18.3204 39.9162 18.1378 39.7336 18.1378 39.5081C18.1378 39.2826 18.3204 39.1 18.5459 39.1C18.7714 39.1 18.954 39.2826 18.954 39.5081Z"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.2056 39.5081C24.2056 39.7336 24.0231 39.9162 23.7975 39.9162C23.572 39.9162 23.3895 39.7336 23.3895 39.5081C23.3895 39.2826 23.572 39.1 23.7975 39.1C24.0231 39.1 24.2056 39.2826 24.2056 39.5081Z"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.4565 39.5081C29.4565 39.7336 29.274 39.9162 29.0484 39.9162C28.8229 39.9162 28.6404 39.7336 28.6404 39.5081C28.6404 39.2826 28.8229 39.1 29.0484 39.1C29.274 39.1 29.4565 39.2826 29.4565 39.5081Z"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8516 43.213L13.23 47.9917C13.0045 48.6683 13.4019 49.4093 13.9817 49.4093H33.6016C34.1815 49.4093 34.5788 48.6683 34.3533 47.9917L32.7317 43.213"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.3886 27.5558C25.761 27.5558 27.6842 25.6327 27.6842 23.2603C27.6842 20.888 25.761 18.9648 23.3886 18.9648C21.0163 18.9648 19.0931 20.888 19.0931 23.2603C19.0931 25.6327 21.0163 27.5558 23.3886 27.5558Z"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.3368 27.4377C31.0671 26.2135 31.4966 24.7852 31.4966 23.2603C31.4966 21.7354 31.0456 20.2105 30.2724 18.9755"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3979 19.1473C15.6891 20.35 15.281 21.7568 15.281 23.2602C15.281 24.6563 15.6354 25.9772 16.2583 27.1262"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.389 15.1524C23.389 15.1524 31.0995 14.7766 37.3603 23.2602C31.0888 31.7439 23.389 31.3681 23.389 31.3681C23.389 31.3681 15.6786 31.7439 9.41782 23.2602C15.6893 14.7766 23.389 15.1524 23.389 15.1524Z"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.5037 7.11974H52.8676"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.5037 10.0729H52.8676"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.5037 13.0261H52.8676"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5069 10.0729H41.8815"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5069 13.0261H41.8815"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.6454 14.8839V16.2477"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.6922 14.8839V16.2477"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.7391 14.8839V16.2477"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.6454 3.88734V5.26191"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.6922 3.88734V5.26191"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.0373 7.11974C46.0373 8.42987 44.9742 9.49302 43.6641 9.49302V13.0261H49.5704V7.11974H46.0373Z"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.9191 17.3147C57.7438 13.49 57.7438 7.28885 53.9191 3.46413C50.0943 -0.360591 43.8932 -0.360589 40.0685 3.46413C36.2438 7.28886 36.2438 13.49 40.0685 17.3147C43.8932 21.1394 50.0943 21.1394 53.9191 17.3147Z"
        stroke={color}
        strokeWidth="1.20275"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_564_17589">
        <rect width="57.3883" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithEyeAndChipSVG;
